import { api } from './ApiService';

export default class RecordService {
    
    static async search(data){
        let response =  await api.post(`/record/search`,data)
        return response.data
    }

    static async create(data){
        let response = await api.post(`/record/create`,data)
        return response.data
    }
    static async update(data){
        let response = await api.post(`/record/update`,data)
        return response.data
    }

    static async delete(id,user_id){
        let response = await api.post(`/record/delete`,{id:id,user_id:user_id})
        return response.data
    }
}


// WEBPACK FOOTER //
// ./src/service/RecordService.js